import axios from "axios";

import { AppStudent } from "../redux/app.slice";

export const TokenAuth = async (student: AppStudent, token: string) => {
  return await axios.get(
    `${process.env.REACT_APP_API_URL}app/token/${student.id}/${student.secret}/${token}`
  );
};
